import { render, staticRenderFns } from "./incoming_call.vue?vue&type=template&id=3956cbde&scoped=true&"
import script from "./incoming_call.vue?vue&type=script&lang=js&"
export * from "./incoming_call.vue?vue&type=script&lang=js&"
import style0 from "./incoming_call.vue?vue&type=style&index=0&id=3956cbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3956cbde",
  null
  
)

export default component.exports